/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Sensor
 */
export interface Sensor {
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    sensorType: SensorSensorTypeEnum;
    /**
     * optional, only if type is a metric
     * @type {string}
     * @memberof Sensor
     */
    metricKey?: string;
}


/**
 * @export
 */
export const SensorSensorTypeEnum = {
    Logs: 'logs',
    Metric: 'metric'
} as const;
export type SensorSensorTypeEnum = typeof SensorSensorTypeEnum[keyof typeof SensorSensorTypeEnum];


/**
 * Check if a given object implements the Sensor interface.
 */
export function instanceOfSensor(value: object): value is Sensor {
    if (!('sensorType' in value) || value['sensorType'] === undefined) return false;
    return true;
}

export function SensorFromJSON(json: any): Sensor {
    return SensorFromJSONTyped(json, false);
}

export function SensorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sensor {
    if (json == null) {
        return json;
    }
    return {
        
        'sensorType': json['sensorType'],
        'metricKey': json['metricKey'] == null ? undefined : json['metricKey'],
    };
}

export function SensorToJSON(json: any): Sensor {
    return SensorToJSONTyped(json, false);
}

export function SensorToJSONTyped(value?: Sensor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sensorType': value['sensorType'],
        'metricKey': value['metricKey'],
    };
}

